export default {
  isLogged: ({ loggedIn }) => loggedIn
};
